export const Settings = {
    ConfigStorageName: "myrewards1",
    DomainServiceUrl: "https://domain.bloyal.io"
}